if (!window.Eurus) window.Eurus = {};
if (!window.Eurus.loadedScript) window.Eurus.loadedScript = new Set();

if (!window.Eurus.loadedScript.has('popup-cep.js')) {
  window.Eurus.loadedScript.add('popup-cep.js');

  var registerCepPopup = function () {
    Alpine.data('xCepPopup', (data) => ({
      show: false,
      cep: '',
      loading: false,
      error: false,
      success: false,
      errorMessage: '',
      successText: '',
      sectionId: data.sectionId,
      delayDays: data.delayDays || 30,
      closeAfterSuccess: !!data.closeAfterSuccess,
      closeMobileMenuOnOpen: data.closeMobileMenuOnOpen !== false,
      storageKey: 'haoma-popup-cep-dismissed',
      cepStorageKey: 'haoma-cep-express',
      openEvent: 'haoma:open-cep-popup',
      gateId: 'cep-popup',
      gateHeld: false,
      shop: data.shop || '',
      apiBase: (data.apiBase || 'https://oms.fullcomm.app').replace(/\/$/, ''),
      requestTimeoutMs: 8000,
      lastFocusedEl: null,
      onKeydown: null,
      feedbackCloseTimer: null,
      gateWatchdog: null,
      popupInitialized: false,

      isDesignMode() {
        return !!(window.Shopify && window.Shopify.designMode);
      },

      init() {
        this.successText = data.successMessage || '';

        this.holdGate();

        // Se o x-init do diálogo não rodar (seção oculta, erro de render), o
        // gate ficaria preso e bloquearia os demais popups da loja.
        this.gateWatchdog = setTimeout(() => {
          this.gateWatchdog = null;
          if (!this.popupInitialized && !this.show) this.releaseGate();
        }, 5000);

        const savedCep = this.getSavedCepDigits();
        if (savedCep) {
          this.cep = savedCep.length > 5 ? savedCep.slice(0, 5) + '-' + savedCep.slice(5) : savedCep;
        }

        if (this.isDesignMode()) {
          document.addEventListener('shopify:section:select', (event) => {
            if (event.detail && event.detail.sectionId.includes(this.sectionId)) {
              this.open(true);
            } else {
              this.close(true);
            }
          });
        }

        window.addEventListener(this.openEvent, () => {
          if (this.closeMobileMenuOnOpen) {
            this.closeMobileMenu();
          }
          this.open(true);
        });
      },

      // Só esconde os drawers (sem chamar close()) para não disputar o estado do xPopup com o CEP.
      closeMobileMenu() {
        try {
          ['xMobileNav', 'xMenuDrawer'].forEach((storeName) => {
            const menu = Alpine.store(storeName);
            if (menu && menu.show) {
              menu.show = false;
            }
          });

          const headerMenu = Alpine.store('xHeaderMenu');
          if (headerMenu) {
            if (headerMenu.openHamburgerMenu) {
              headerMenu.openHamburgerMenu = false;
            }
            if (typeof headerMenu.closeMenu === 'function') {
              headerMenu.closeMenu();
            }
          }
        } catch (e) {
          /* store ainda não disponível */
        }
      },

      initPopup() {
        this.popupInitialized = true;
        if (this.gateWatchdog) {
          clearTimeout(this.gateWatchdog);
          this.gateWatchdog = null;
        }

        if (window.location.pathname === '/challenge') {
          this.releaseGate();
          return;
        }

        if (this.isDesignMode()) {
          this.open(true);
          return;
        }

        if (this.hasValidSavedCep()) {
          this.releaseGate();
          return;
        }

        if (!this.isDismissed()) {
          this.open(false);
        } else {
          this.releaseGate();
        }
      },

      holdGate() {
        if (this.gateHeld) return;
        this.gateHeld = true;
        window.dispatchEvent(new CustomEvent('haoma:popup-gate-hold', { detail: { id: this.gateId } }));
      },

      releaseGate() {
        if (!this.gateHeld) return;
        this.gateHeld = false;
        window.dispatchEvent(new CustomEvent('haoma:popup-gate-release', { detail: { id: this.gateId } }));
      },

      getDialogEl() {
        return document.getElementById('x-cep-popup-' + this.sectionId);
      },

      getFocusableEls() {
        const dialog = this.getDialogEl();
        if (!dialog) return [];
        const selector =
          'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
        return Array.prototype.slice
          .call(dialog.querySelectorAll(selector))
          .filter((el) => el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement);
      },

      trapFocus(event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          event.preventDefault();
          this.close();
          return;
        }

        if (event.key !== 'Tab') return;

        const focusable = this.getFocusableEls();
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        const active = document.activeElement;

        if (event.shiftKey && active === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && active === last) {
          event.preventDefault();
          first.focus();
        }
      },

      open(force) {
        if (!force && this.isDismissed()) return;
        if (this.show) return;

        if (this.feedbackCloseTimer) {
          clearTimeout(this.feedbackCloseTimer);
          this.feedbackCloseTimer = null;
        }

        this.holdGate();

        const manageFocus = !this.isDesignMode();
        if (manageFocus) {
          this.lastFocusedEl = document.activeElement;
        }
        this.show = true;

        if (manageFocus) {
          this.onKeydown = (event) => this.trapFocus(event);
          document.addEventListener('keydown', this.onKeydown);
        }

        requestAnimationFrame(() => {
          document.body.classList.add('overflow-hidden');
          if (Alpine.store('xPopup')) {
            Alpine.store('xPopup').open = true;
          }
          if (!manageFocus) return;
          const focusable = this.getFocusableEls();
          const target = document.getElementById('cep-input-' + this.sectionId) || focusable[0];
          if (target && typeof target.focus === 'function') {
            target.focus();
          }
        });
      },

      close(skipPersist) {
        if (this.feedbackCloseTimer) {
          clearTimeout(this.feedbackCloseTimer);
          this.feedbackCloseTimer = null;
        }

        this.show = false;
        this.loading = false;

        this.releaseGate();

        if (this.onKeydown) {
          document.removeEventListener('keydown', this.onKeydown);
          this.onKeydown = null;
        }

        if (!skipPersist && !this.isDesignMode()) {
          this.persistDismiss();
        }

        requestAnimationFrame(() => {
          document.body.classList.remove('overflow-hidden');
          if (Alpine.store('xPopup')) {
            Alpine.store('xPopup').close();
          }
          if (this.lastFocusedEl && typeof this.lastFocusedEl.focus === 'function') {
            this.lastFocusedEl.focus();
            this.lastFocusedEl = null;
          }
        });
      },

      isDismissed() {
        try {
          const raw = localStorage.getItem(this.storageKey);
          if (!raw) return false;
          const saved = JSON.parse(raw);
          if (!saved || !saved.expiresAt) return false;
          return Date.now() < saved.expiresAt;
        } catch (e) {
          return false;
        }
      },

      getSavedCepData() {
        try {
          const raw = localStorage.getItem(this.cepStorageKey);
          if (!raw) return null;
          const saved = JSON.parse(raw);
          if (!saved || !saved.cep || !Array.isArray(saved.locations) || !saved.locations.length) {
            return null;
          }
          return saved;
        } catch (e) {
          return null;
        }
      },

      getSavedCepDigits() {
        const saved = this.getSavedCepData();
        return saved ? String(saved.cep).replace(/\D/g, '').slice(0, 8) : '';
      },

      hasValidSavedCep() {
        const saved = this.getSavedCepData();
        if (!saved) return false;

        const ttlDays = typeof saved.ttl_days === 'number' ? saved.ttl_days : this.delayDays;
        if (saved.resolved_at) {
          const resolved = Date.parse(saved.resolved_at);
          if (!isNaN(resolved) && Date.now() - resolved > ttlDays * 24 * 60 * 60 * 1000) {
            return false;
          }
        }
        return true;
      },

      persistDismiss() {
        try {
          const expiresAt = Date.now() + this.delayDays * 24 * 60 * 60 * 1000;
          localStorage.setItem(
            this.storageKey,
            JSON.stringify({ dismissedAt: Date.now(), expiresAt: expiresAt })
          );
        } catch (e) {
          /* ignore quota / private mode */
        }
      },

      onCepInput(event) {
        this.error = false;
        this.success = false;
        const digits = (event.target.value || '').replace(/\D/g, '').slice(0, 8);
        if (digits.length > 5) {
          this.cep = digits.slice(0, 5) + '-' + digits.slice(5);
        } else {
          this.cep = digits;
        }
      },

      getCepDigits() {
        return (this.cep || '').replace(/\D/g, '');
      },

      isValidCep() {
        return /^\d{8}$/.test(this.getCepDigits());
      },

      // A API pode devolver `covered` como boolean ou string ("false" é truthy em JS).
      isCovered(payload) {
        if (!payload) return false;
        const covered = payload.covered;
        const isTrue = covered === true || covered === 1 || String(covered).toLowerCase() === 'true';
        if (!isTrue) return false;
        const locations = Array.isArray(payload.locations) ? payload.locations : [];
        return locations.some((loc) => loc && String(loc.locationId || '').length > 0);
      },

      async parseCheckCepResponse(response) {
        if (response.status === 404) {
          try {
            return { payload: await response.json(), uncovered: true };
          } catch (e) {
            return { payload: {}, uncovered: true };
          }
        }

        if (!response.ok) {
          throw new Error('api');
        }

        let payload = {};
        try {
          payload = await response.json();
        } catch (e) {
          payload = {};
        }

        return { payload, uncovered: !this.isCovered(payload) };
      },

      finishUncoveredCep(payload) {
        this.persistCepResult(payload || {});
        if (!this.isDesignMode()) {
          this.persistDismiss();
        }
        this.success = false;
        this.error = true;
        this.errorMessage = data.errorNotFound || 'Não há entrega expressa disponível para esta região.';
        window.dispatchEvent(new CustomEvent('haoma:cep-updated'));
        this.closeAfterFeedback();
      },

      fallbackToStandardWithApiError() {
        // Em falha de API não alteramos o estado de cobertura salvo, para
        // não transformar temporariamente o carrinho inteiro em padrão.
      },

      closeAfterFeedback() {
        if (this.feedbackCloseTimer) {
          clearTimeout(this.feedbackCloseTimer);
        }
        this.feedbackCloseTimer = setTimeout(() => {
          this.close(true);
          this.feedbackCloseTimer = null;
        }, 900);
      },

      persistCepResult(payload) {
        const covered = this.isCovered(payload);
        const locations = !covered ? [] : (payload.locations || []).map((loc) => ({
          locationId: String(loc.locationId || ''),
          name: loc.name || '',
          cepDelta: typeof loc.cepDelta === 'number' ? loc.cepDelta : null
        })).filter((loc) => loc.locationId);

        const saved = {
          cep: this.getCepDigits(),
          uf: payload.uf || '',
          covered: covered,
          locations: locations,
          resolved_at: new Date().toISOString(),
          ttl_days: this.delayDays
        };

        try {
          localStorage.setItem(this.cepStorageKey, JSON.stringify(saved));
        } catch (e) {
          /* ignore quota / private mode */
        }

        return saved;
      },

      async verificar() {
        if (this.loading) return;

        this.error = false;
        this.success = false;
        this.errorMessage = '';

        if (!this.isValidCep()) {
          this.error = true;
          this.errorMessage = data.errorInvalid || 'Informe um CEP válido com 8 dígitos.';
          return;
        }

        if (!this.shop) {
          this.error = true;
          this.errorMessage = data.errorApi || 'Não foi possível consultar o CEP. Tente novamente.';
          return;
        }

        this.loading = true;

        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), this.requestTimeoutMs);

        try {
          const cep = this.getCepDigits();
          const url = this.apiBase + '/geolocation/check-cep/' + encodeURIComponent(this.shop) + '/' + encodeURIComponent(cep);
          const response = await fetch(url, {
            method: 'GET',
            headers: { Accept: 'application/json' },
            signal: controller.signal
          });

          const { payload, uncovered } = await this.parseCheckCepResponse(response);

          if (uncovered) {
            this.finishUncoveredCep(payload);
            return;
          }

          this.persistCepResult(payload);
          if (!this.isDesignMode()) {
            this.persistDismiss();
          }
          this.success = true;
          this.successText = data.successMessage || '';
          window.dispatchEvent(new CustomEvent('haoma:cep-updated'));

          if (this.closeAfterSuccess) {
            setTimeout(() => {
              this.close(true);
            }, 900);
          }
        } catch (e) {
          this.fallbackToStandardWithApiError();
          this.error = true;
          this.errorMessage = data.errorApi || 'Não foi possível consultar o CEP. Tente novamente.';
          this.closeAfterFeedback();
        } finally {
          clearTimeout(timeoutId);
          this.loading = false;
        }
      }
    }));
  };

  if (window.Alpine) {
    registerCepPopup();
  } else {
    document.addEventListener('alpine:init', registerCepPopup);
  }
}
